<template>
    <div class="a-toggle-switch">
        <p :class="['label-text', {'label-end': labelEnd}]">{{label}}</p>
        <input
            :id="`switch-${uniqueID}`"
            v-model="value"
            type="checkbox"
        /><label :for="`switch-${uniqueID}`"></label>
    </div>
</template>

<script setup>
import { computed } from 'vue';

const props = defineProps({
    uniqueID: {
        type: [String, Number],
        default: '',
    },
    switchToggled: {
        type: Boolean,
        defualt: true,
    },
    label: {
        type: String,
        default: ''
    },
    labelEnd: {
        type: Boolean,
        default: false
    }
})
const emit = defineEmits(['switch'])

const value = computed({
    get() {
        return props.switchToggled;
    },
    set(value) {
        emit('switch', { value: value, id: props.uniqueID });
    }
})

</script>

<script>
    export default {
        name: 'AonToggleSwitch'
    }
</script>

<style lang="scss">
$pillWidth: 52px;
$pillHeight: 24px;

.a-toggle-switch {
    position: relative;
    height: $pillHeight;
    display: flex;
    align-items: center;

    p {
        margin: 0 10px;
    }

    .label-end {
        order: 1000;
    }

    input[type='checkbox'] {
        height: 0;
        width: 0;
        visibility: hidden;
        margin: 0;
        top: 0;
    }

    label {
        cursor: pointer;
        text-indent: -9999px;
        width: $pillWidth;
        height: $pillHeight;
        background: grey;
        display: block;
        border-radius: 50px;
        position: relative;
        // overwrite global
        margin: 0 !important;
        margin-top: 0 !important;
    }

    label:after {
        content: '';
        position: absolute;
        top: 3px;
        left: 3px;
        width: 18px;
        height: 18px;
        background: #fff;
        border-radius: 40px;
        transition: 0.3s;
    }

    input:checked + label {
        background: $castleMoat;
    }

    input:checked + label:after {
        left: calc(100% - 3px);
        transform: translateX(-100%);
    }

    label:active:after {
        width: 25px;
    }
}
</style>
